@if (personLogin) {
  <div>
    <table class="mainContentGrid">
      <tbody>
        <tr>
          <td class="thirdPageColumn">
            <table class="linkTable">
              <tr>
                <td class="tableCell centeredCell headerCell">Quick Links</td>
              </tr>
              <!-- <tr>
                <span class="quickLink" (click)="downloadHolidaySchedule()">Holiday Schedule</span>
              </tr> -->
              @if (!hasRole('CredAnalyst') && !hasRole('ReadOnly')) {
                <tr>
                  <span class="quickLink" (click)="showPartsDialog()">
                    Parts & Warranty
                  </span>
                </tr>
              }
              <tr>
                <a routerLink="training" routerLinkActive="linkActive">Training</a>
              </tr>
              <tr>
                <a href="https://wkf.ms/44POmA1" target="_blank">
                  Feedback Form
                </a>
              </tr>
              <tr>
                <a [routerLink]="['marketing']" [queryParams]="{documents: true}">Documentation</a>
              </tr>
              <!-- <tr>
              <a
                href="https://forms.office.com/pages/responsepage.aspx?id=x8vTmiIlSkqVmpsh0AX7aLc9NiD0uKxOsBsS85pKjxlUMU85R1dPNDkxOTVVSU9XV1FHS1ZTV1ZIUy4u&wdLOR=c25E06956-77CF-422A-95E0-50321405A935"
                target="_blank">
                Engineering Office Online Ratings Registration Form
              </a>
            </tr> -->
            <!--<tr>
            <a [routerLink]="['marketing']" [queryParams]="{presentations: true}">Sales and Marketing Tools</a>
          </tr> -->
          <tr>
            <a [href]="getLeadTimeUrl()" target="_blank">Current Lead Times</a>
          </tr>
          <!--<tr>
          <a routerLink="myContacts" routerLinkActive="linkActive">My Contacts</a>
        </tr> -->
        <tr>
          <span class="quickLink" (click)="openUserPerformanceDefaultsDialog()">Performance Defaults</span>
        </tr>
        @if (hasRole('IT') || (!hasRole('CredAnalyst') && !hasRole('ReadOnly'))) {
          <tr>
            <span class="quickLink" (click)="openStockUnitsDialog()">Quick Units</span>
          </tr>
        }
        <tr>
          <a [routerLink]="['marketing']" [queryParams]="{documents: true, category: 'R410A Parts Catalogs'}">Parts Catalogs</a>
        </tr>
        <tr>
          <span class="quickLink" (click)="showFindOrdersDialog()">Find Orders</span>
        </tr>
        @if (isInternalUser) {
          <tr>
            <a [routerLink]="['reports']">Reports</a>
          </tr>
          <tr>
            <a [routerLink]="['partNumberDecoder']">Part Number Decoder</a>
          </tr>
        }
      </table>
    </td>
    <td class="thirdPageColumn">
      <table class="displayTable">
        <thead>
          <tr>
            <td class="tableCell centeredCell headerCell">Tasks</td>
          </tr>
        </thead>
      </table>
      <table mat-table [dataSource]="taskDataSource" matSort class="taskTable">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="tableCell centeredCell headerCell titleColumn">Title</th>
          <td mat-cell *matCellDef="let iecTask" class="tableCell">
            @if (iecTask.targetUrl && iecTask.targetUrl.length > 0) {
              <a href="{{iecTask.targetUrl}}" target="_blank">{{ iecTask.name }}</a>
            } @else {
              {{ iecTask.name }}
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="entityId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="tableCell centeredCell headerCell entityIdColumn">Entity Id</th>
          <td mat-cell *matCellDef="let iecTask" class="tableCell">{{ iecTask.entityId }}</td>
        </ng-container>
        <ng-container matColumnDef="entityRevision">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="tableCell centeredCell headerCell entityRevisionColumn">Entity Revision</th>
          <td mat-cell *matCellDef="let iecTask" class="tableCell">{{ iecTask.entityRevision }}</td>
        </ng-container>
        <ng-container matColumnDef="startTime">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="tableCell centeredCell headerCell createDateColumn">Created</th>
          <td mat-cell *matCellDef="let iecTask" class="tableCell">{{ iecTask.startTime | date: 'MM/dd/yyyy' }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="taskColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: taskColumns;"></tr>
        <tr *matNoDataRow>
          <td class="tableCell" [attr.colspan]="taskColumns.length">No records found</td>
        </tr>
      </table>
    </td>
    <td class="thirdPageColumn">
      @if (marketingImage1()) {
        <img class="marketingImage" alt="" [src]="marketingImage1()"/>
      }
      @if (marketingImage2()) {
        <img class="marketingImage" alt="" [src]="marketingImage2()"/>
      }
      @for (newsAnnouncement of newsAnnouncements(); track newsAnnouncement) {
        <table class="displayTable">
          <tr>
            <td class="tableCell centeredCell headerCell">{{ newsAnnouncement.headlineText }}</td>
          </tr>
          <tr>
            <td class="tableCell" [innerHTML]="newsAnnouncement.details"></td>
          </tr>
        </table>
      }
    </td>
  </tr>
</tbody>
</table>
</div>
}

